module.exports = __webpack_public_path__ + "static/profile-f283afdd1cf9728c1e83d0d068738891.png";